// How far an audio clip's edges may be dragged. An audio clip is a window onto
// its source file, so resizing it is trimming: either edge can uncover what an
// earlier trim hid, but never reach past the file's first or last sample.
// Video is different — its outer clip is stage presence, decoupled from the
// source — and does not go through here.
//
// Kept pure and separate from TrackClip so the frame/offset math can be
// tested: the two audio shapes express their in-point differently (scene-audio
// in seconds via audioOffset, audio boxes in frames via trimStart).

/** Where the clip's first frame sits inside its source file, in frames. */
export function sourceInFrames(layer, fps) {
  if (layer.type === "scene-audio") {
    return Math.max(0, (parseFloat(layer.audioData?.audioOffset) || 0) * fps);
  }
  return Math.max(0, layer.trimStart ?? 0);
}

/** Earliest start a left-edge drag may reach: the source's first sample. */
export function minSourceStartFrame(layer, fps) {
  // ceil, so a fractional in-point never resolves to a negative offset.
  return Math.max(0, Math.ceil(layer.startFrame - sourceInFrames(layer, fps)));
}

/**
 * Latest end a right-edge drag may reach: the source's last sample. null while
 * the source length is still unknown (probe pending or failed).
 */
export function maxSourceEndFrame(layer, fps) {
  const total = layer.mediaDurationFrames;
  if (typeof total !== "number" || !(total > 0)) return null;
  return Math.floor(layer.startFrame + total - sourceInFrames(layer, fps));
}
